var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Fragment,[(!_setup.data?.data?.length)?_c(_setup.SmartCampaign):_c(_setup.FlashPick,{attrs:{"products":_setup.data?.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }